var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"small text-danger"},[_vm._v(" "+_vm._s(_vm.notice)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }